import type { CustomCssVarsFn } from '@wix/yoshi-flow-editor';

import * as wui from 'settings/wui';
import * as feed from 'settings/feed';
import { getFeedCssVars } from 'settings/feed/vars';
import * as groups from 'settings/groups';
import * as membersAreaGroups from 'settings/members-area-groups';
import { getGroupsCssVars } from 'settings/groups/vars';
import { application } from 'settings/common';
import { createStylesParam, StyleParamType } from '@wix/tpa-settings';

// TODO: Default font size for mobile and css per breakpoint
export default {
  ...wui.styles,
  ...feed.styles,
  ...groups.styles,
  ...application.styles,
  ...membersAreaGroups.styles,
  vSpacing: createStylesParam('vSpacing', {
    type: StyleParamType.Number,
    getDefaultValue: () => 20,
  }),
};

// noinspection JSUnusedGlobalSymbols
export const customCssVars: CustomCssVarsFn = (params) => ({
  ...getGroupsCssVars(params),
  ...getFeedCssVars(params),
});
